import { baseApiUrl } from "../../../../../env";
import axiosInstance from "../../../../../Axios/axios";



const GetHourlyStepCountChart=async(body)=>{
const getRangeLpiOfCustomer_URL='Dashboard/GetHourlyStepCountChart';
return await axiosInstance.post(getRangeLpiOfCustomer_URL,body)
}



// http://192.168.3.17:91/api/v1/Dashboard/GetOperatorStepCountChart


const GetOperatorStepCountChart=async(body)=>{
const getOperatorStepCountChart_URL='Dashboard/GetOperatorStepCountChart';
return await axiosInstance.post(getOperatorStepCountChart_URL,body)
}


export {
    GetHourlyStepCountChart,
    GetOperatorStepCountChart
}








// export const useGetHourlyOrderRegisterCountChart = () => {
//   return useMutation((body) =>
//     customApi({
//       apiType: "post",
//       url: "/api/v1/Dashboard/GetHourlyStepCountChart",
//       reactQuery: "mutate",
//       requestBody: body,
//     })
//   );
// };



